import { render } from "./PuntoVentaCreate.vue?vue&type=template&id=4e82ee99&scoped=true"
import script from "./PuntoVentaCreate.vue?vue&type=script&lang=js"
export * from "./PuntoVentaCreate.vue?vue&type=script&lang=js"

import "./PuntoVentaCreate.vue?vue&type=style&index=0&id=4e82ee99&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e82ee99"]])

export default __exports__